var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table-filter',{attrs:{"filterComponents":[
      {
        type: 'DateRangeFilter',
        name: 'whereDate',
        attributes: { dateField: 'created_at' }
      }
    ]},on:{"input":function($event){_vm.loading = true},"apply-filters":function($event){return _vm.$bus.$emit('refresh-table')}},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"spinner"},[_c('i',{staticClass:"fas fa-sync fa-7x fa-spin spinner"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('chart-card',{attrs:{"chart-data":_vm.messageChart,"chart-options":_vm.messageChart.options,"chart-height":250,"chart-type":"Pie"}},[_c('template',{slot:"header"},[_c('h2',{staticClass:"card-title"},[_vm._v("Nachrichtentypen")])]),_vm._v(" "),_c('template',{slot:"footer"},[_c('div')])],2)],1),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('v-table',{ref:"table",attrs:{"url":"/api/v1/message/count-types","appends":['messagesCount', 'dEType'],"filter":_vm.filter,"attributes":[
          {
            attribute: 'dEType',
            name: 'Typ',
            sortable: false
          },
          {
            attribute: 'typeCount',
            type: 'DoubleValueThousendSeperatCell',
            name: 'Anzahl',
            sortable: false
          },
          {
            secondAttribute: _vm.messagesCount,
            type: 'DoubleValuePercentageCell',
            name: 'Anteil',
            sortable: false
          }
        ]},on:{"table-fetched":_vm.tableFetched}},[_c('tr',{attrs:{"slot":"bottom"},slot:"bottom"},[_c('td',[_c('strong',[_vm._v("\n              Gesamt:\n            ")])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v("\n              "+_vm._s(_vm.messagesCountSpeparated)+"\n            ")])]),_vm._v(" "),_c('td')])])],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }